import { TabsContent } from "@/components/ui/tabs.tsx";
import AccountTab from "@/components/SettingsSidepanel/Account/Account";
import { SettingsProps } from "@/components/SettingsSidepanel/settings.types.ts";
import SlapshotIntegrationTab from "@/components/SettingsSidepanel/Integrations/SlapshotIntegration";
import IntegrationTab from "@/components/SettingsSidepanel/Integrations/Integration.tsx";
import UsersTab from "@/components/SettingsSidepanel/Users/Users.tsx";

const SettingsTabs: React.FC<SettingsProps> = ({ onRequestClose }) => {
  return (
    <div className="flex-1">
      <TabsContent
        value="account"
        className="h-full w-full items-center p-4 pt-0"
      >
        <AccountTab onRequestClose={onRequestClose} />
      </TabsContent>
      <TabsContent
        value="users"
        className="h-full w-full items-center p-4 pt-0"
      >
        <UsersTab onRequestClose={onRequestClose} />
      </TabsContent>
      <TabsContent
        value="slapshot-integration"
        className="h-full items-center p-4 pt-0"
      >
        <SlapshotIntegrationTab onRequestClose={onRequestClose} />
      </TabsContent>
      <TabsContent value="integration" className="h-full items-center p-4 pt-0">
        <IntegrationTab onRequestClose={onRequestClose} />
      </TabsContent>
    </div>
  );
};

export default SettingsTabs;
